'use strict';

var styled = require('styled-components');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

// NOTE: Tab cannot be referred directly by the Tabs component ; this styled.div`` allows that.
// The aim is to control Tab styles _via_ its parent, as it must only live in the <Tabs /> context.
// See https://styled-components.com/docs/advanced#caveat
const Tab = styled__default.default.div ``;

exports.Tab = Tab;
//# sourceMappingURL=Tab.js.map
